<template>
  <footer>
    <div class="container">
      <div class="inner">
        <div class="footer__copyright">
          <p>© {{ year }} Arkansas Razorbacks. All Rights Reserved</p>
        </div>
        <div class="footer__powered-by">
          <a href="https://wmt.digital/" target="_blank" rel="nofollow" title="Powered by WMT.digital">
            <span>Powered by</span>
            <img src="/wp-content/themes/arkansasTheme/build/images/wmt_logo.png" alt="Powered by WMT.digital">
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  computed: {
    year() {
      return (new Date()).getFullYear()
    }
  }
}
</script>
